import { render, staticRenderFns } from "./TikTokAnalyticsPublicChart.vue?vue&type=template&id=70f203c7&scoped=true"
import script from "./TikTokAnalyticsPublicChart.vue?vue&type=script&lang=ts"
export * from "./TikTokAnalyticsPublicChart.vue?vue&type=script&lang=ts"
import style0 from "./TikTokAnalyticsPublicChart.vue?vue&type=style&index=0&id=70f203c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f203c7",
  null
  
)

export default component.exports